import { LayoutGraph, Insets, LayoutNode } from '@ardoq/yfiles';
import { isTruthy } from '@ardoq/common-helpers';
import {
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  INVISIBLE_SEPARATOR,
} from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import { layoutGroupHeaderLabels } from '../groupHeader/layoutGroupHeaderLabels';
import {
  HAS_REPRESENTATION_DATA,
  HAS_URL_FIELDS,
  MAIN_LABEL,
  MODERNIZED_BLOCK_DIAGRAM_LEFT_INSET as LEFT_INSET,
  OTHER_LABELS,
  SUB_LABEL,
} from './consts';

const groupNodeInsets = (graph: LayoutGraph, dataHolder: LayoutNode) => {
  const nodeWidth = dataHolder.layout.width;

  const mainLabelProvider = graph.context.getItemData(MAIN_LABEL);
  const mainLabel = mainLabelProvider?.get(dataHolder);
  if (!mainLabel) {
    return Insets.EMPTY;
  }

  const subLabelProvider = graph.context.getItemData(SUB_LABEL);
  const subLabel = subLabelProvider?.get(dataHolder);
  const subLabelResolved =
    (subLabel === INVISIBLE_SEPARATOR ? null : subLabel) ?? null;
  const hasUrlFieldsProvider = graph.context.getItemData(HAS_URL_FIELDS);
  const hasUrlFields = Boolean(hasUrlFieldsProvider?.get(dataHolder));

  const hasRepresentationDataProvider = graph.context.getItemData(
    HAS_REPRESENTATION_DATA
  );
  const hasRepresentationData = Boolean(
    hasRepresentationDataProvider?.get(dataHolder)
  );
  const otherLabelsProvider = graph.context.getItemData(OTHER_LABELS);
  const concatenatedOtherLabels = otherLabelsProvider?.get(dataHolder);
  const otherLabels =
    concatenatedOtherLabels?.split(INVISIBLE_SEPARATOR).filter(isTruthy) ??
    null;
  const { mainLabelHeight, subLabelHeight, otherLabelsHeight } =
    layoutGroupHeaderLabels({
      mainLabel,
      subLabel: subLabelResolved,
      otherLabels,
      nodeWidth,
      hasUrlFields,
      hasRepresentationData,
    });
  const stripeHeight = 2 * PADDING + Math.max(mainLabelHeight, EXPANDER_SIZE);
  const underStripeHeight = Math.max(
    PADDING,
    subLabelHeight + otherLabelsHeight
  );
  const topInset = stripeHeight + underStripeHeight;

  return new Insets(topInset, PADDING, PADDING, LEFT_INSET);
};

export { groupNodeInsets };
